import ConfirmModal from './ConfirmModal';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '@/redux/root';
import { cancelAction, confirmAction } from '@/redux/slices/confirmation';

const ConfirmationModalContainer = () => {
  const dispatch = useDispatch();

  const { isOpen, title, subtitle, confirmButton, cancelButton } = useSelector((state: AppState) => state.confirmation);

  if (!isOpen) return null;

  return (
    <ConfirmModal
      title={title}
      message={subtitle}
      confirmButtonText={confirmButton.text}
      cancelButtonText={cancelButton.text}
      onClose={() => dispatch(cancelAction())}
      onConfirm={() => dispatch(confirmAction())}
    />
  );
};

export default ConfirmationModalContainer;
